export const PATHS = {
  home: '/',
  login: '/login',
  dashboard: '/dashboard',
} as const;

export type Path = (typeof PATHS)[keyof typeof PATHS];
